export default __webpack_public_path__ + "static/media/13.30591705.png";